import { Component, Output, EventEmitter, Input, OnChanges, DoCheck, KeyValueDiffers, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ClosetDoorsStandardService } from 'src/app/services/configurators-2d/applications/closet-doors-standard.service';

@Component({
  selector: 'ng-closet-doors-standard-environment',
  templateUrl: './environment.component.html',
})
export class ClosetDoorsStandardEnvironmentComponent implements OnInit, OnChanges, DoCheck {
  @Input() emplacements: any;

  @Input() selectedEmplacement: any;

  //Est-ce que l'emplacement a déjà des tiroirs
  @Input() hasDrawers: boolean;

  @Input() drawersLocation: number;

  @Output() onEmplacementSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() onHasDrawersSelect: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onDrawersLocationSelect: EventEmitter<any> = new EventEmitter<any>();

  //Emplacement du/des tiroir(s)
  drawerLeft = false;
  drawerCenter = false;
  drawerRight = false;

  //URL de base des images
  baseImgURL = undefined;

  currentLang: string;

  // Refresh
  differ: any;

  constructor(
    private translate: TranslateService,
    private closetDoorsService: ClosetDoorsStandardService,
    private differs: KeyValueDiffers
  ) {}

  ngOnInit(): void {
    this.baseImgURL = this.closetDoorsService.apiUrl;
    this.currentLang = this.translate.getBrowserLang();
    if (this.emplacements !== undefined) {
      this.selectEmplacement(this.emplacements.find(x => x.displayOrder == 1));
    }
    this.differ = this.differs.find({}).create();
  }

  ngDoCheck(): void {
    const change = this.differ.diff(this);
    if (change) {
      change.forEachChangedItem(item => {
        // Ecoute le chargement de l'appel pour récupérer les emplacements, à la suite sélection automatique du premier. La première fois uniquement.
        if (item.key == 'emplacements' && item.previousValue == undefined) {
          this.selectEmplacement(this.emplacements[item.currentValue.findIndex(x => x.displayOrder == 1)]);
        }
      });
    }
  }

  ngOnChanges(): void {
    if (this.drawersLocation !== null && this.drawersLocation !== undefined) {
      switch (this.drawersLocation) {
        case 2:
          this.drawerLeft = true;
          this.drawerCenter = false;
          this.drawerRight = false;
          break;
        case 4:
          this.drawerLeft = false;
          this.drawerCenter = true;
          this.drawerRight = false;
          break;
        case 6:
          this.drawerLeft = true;
          this.drawerCenter = true;
          this.drawerRight = false;
          break;
        case 8:
          this.drawerLeft = false;
          this.drawerCenter = false;
          this.drawerRight = true;
          break;
        case 10:
          this.drawerLeft = true;
          this.drawerCenter = false;
          this.drawerRight = true;
          break;
        case 12:
          this.drawerLeft = false;
          this.drawerCenter = true;
          this.drawerRight = true;
          break;
        case 14:
          this.drawerLeft = true;
          this.drawerCenter = true;
          this.drawerRight = true;
          break;
        default:
          this.drawerLeft = false;
          this.drawerCenter = false;
          this.drawerRight = false;
          break;
      }
    }
  }

  /**
   * Fonction de sélection de l'emplacement
   * @param emplacement emplacement à sélectionner
   */
  selectEmplacement(emplacement: any) {
    this.selectedEmplacement = emplacement.id;
    this.onEmplacementSelect.emit(emplacement);
  }

  /**
   * Fonction de sélection s'il y a des tiroirs ou non
   * @param hasDrawers y a t il des tiroirs
   */
  selectHasDrawers() {
    if (!this.hasDrawers) {
      this.drawerLeft = false;
      this.drawerCenter = false;
      this.drawerRight = false;
      this.selectDrawersLocation();
    }

    this.onHasDrawersSelect.emit(this.hasDrawers);
  }

  /**
   * Fonction de sélection de l'emplacement des tiroirs
   */
  selectDrawersLocation() {
    let drawers = 0;

    if (this.drawerLeft) {
      drawers += 2;
    }

    if (this.drawerCenter) {
      drawers += 4;
    }

    if (this.drawerRight) {
      drawers += 8;
    }

    this.onDrawersLocationSelect.emit(drawers);
  }

  /**
   * Fonction de détermination si l'emplacement est sélectionné ou non
   * @param id id de l'emplacement
   * @returns boolean
   */
  isEmplacementSelected(id: number) {
    if (this.selectedEmplacement?.id === id || this.selectedEmplacement === id) {
      return true;
    } else {
      return false;
    }
  }
}
